export default "__VITE_ASSET__BYF4SCMQ__"